import axios from '@/axios/'

const actions = {
  getQRinfo(_, param) {
    return axios.post('/GetTktQRinfo/1.0/', param)
  },
  getPassBook(_, param) {
    return axios.post('/GetPassbook/1.0/', param, { responseType : 'blob' })
  }
}

export default {
  namespaced: true,
  actions,
}
